// Components
import { GroupSectionTitle, Tournament } from '@velinsi/smp-widgets-ui';
import MatchList from './MatchList';

// Types
import {
  INormalizedFootballGameData,
  INormalizedRoundData,
  INormalizedTournamentData,
  IOddsV2,
  ISubscriberInfo,
  ITournamentProps,
  OddsMarketScope,
  SportType,
} from '../../../../../packages/types';
import { INormalizedLivescoreMatchData, ITeamWinnerForm } from '../../types';

interface IGroupSectionProps {
  matches?:
    | INormalizedLivescoreMatchData[]
    | {
        info?: INormalizedFootballGameData;
        teamWinnerForm?: ITeamWinnerForm;
        odds?: IOddsV2;
      }[];
  round?: INormalizedRoundData;
  tournament?: INormalizedTournamentData;
  handleClick: (info: ISubscriberInfo, clickType: string) => void;
  handleEventClick?: (id: string | number) => void;
  handleTournamentClick?: ITournamentProps['handleTournamentClick'];
  showOdds?: boolean;
  sport?: SportType;
  showTeamWinnerForm?: boolean;
  selectedTeamId?: string;
  allowInlineOdds?: boolean;
  oneLine?: boolean;
  oddsMarketScope?: OddsMarketScope;
}

function GroupSection({
  matches,
  round,
  tournament,
  handleClick,
  handleTournamentClick,
  showOdds,
  sport,
  handleEventClick,
  showTeamWinnerForm,
  selectedTeamId,
  allowInlineOdds = true,
  oneLine,
  oddsMarketScope,
}: IGroupSectionProps): JSX.Element {
  return (
    <>
      {tournament && <Tournament sport={sport} tournament={tournament} handleTournamentClick={handleTournamentClick} />}

      {round && <GroupSectionTitle title={round?.name} />}

      <MatchList
        showOdds={showOdds}
        matches={matches}
        handleClick={handleClick}
        handleEventClick={handleEventClick}
        showTeamWinnerForm={showTeamWinnerForm}
        selectedTeamId={selectedTeamId}
        allowInlineOdds={allowInlineOdds}
        oneLine={oneLine}
        oddsMarketScope={oddsMarketScope}
      />
    </>
  );
}

export default GroupSection;
